import { render, staticRenderFns } from "./StepSelectDocumentType.vue?vue&type=template&id=6c738588&scoped=true&"
import script from "./StepSelectDocumentType.vue?vue&type=script&lang=js&"
export * from "./StepSelectDocumentType.vue?vue&type=script&lang=js&"
import style0 from "./StepSelectDocumentType.vue?vue&type=style&index=0&id=6c738588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c738588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c738588')) {
      api.createRecord('6c738588', component.options)
    } else {
      api.reload('6c738588', component.options)
    }
    module.hot.accept("./StepSelectDocumentType.vue?vue&type=template&id=6c738588&scoped=true&", function () {
      api.rerender('6c738588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/customDocuments/StepSelectDocumentType.vue"
export default component.exports